import { useEffect, useRef } from 'react';

// useReveal.js
export default function useReveal(threshold = 0.15, dep = null) {
  const ref = useRef(null);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;

    // Reset all reveal elements before re-observing
    const targets = container.querySelectorAll('.reveal, .reveal-group');
    targets.forEach((el) => el.classList.remove('visible'));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [threshold, dep]); // ✅ re-runs when dep (isMobile) changes

  return ref;
}